export const EVAL_STATUS_TABLE = [
    { code: "incomplete", shortLabel: "Incomplete", longLabel: "Incomplete \u2013 Does not have all evaluations", colorClass: "bg-destructive/10 text-destructive border-destructive/20" },
    { code: "puppy_needs_review", shortLabel: "Puppy \u2013 Needs Review", longLabel: "Puppy \u2013 Needs Review", colorClass: "bg-warning/10 text-warning border-warning/20" },
    { code: "needs_review", shortLabel: "Needs Review", longLabel: "Needs Review", colorClass: "bg-warning/10 text-warning border-warning/20" },
    { code: "needs_recs", shortLabel: "Needs Recs", longLabel: "Needs Recs", colorClass: "bg-warning/10 text-warning border-warning/20" },
    { code: "complete", shortLabel: "Complete", longLabel: "Complete", colorClass: "bg-success/10 text-success border-success/20" },
    { code: "error", shortLabel: "Error", longLabel: "Error", colorClass: "bg-destructive/10 text-destructive border-destructive/20" },
    { code: "unknown", shortLabel: "Unknown", longLabel: "Unknown", colorClass: "bg-destructive/10 text-destructive border-destructive/20" },
];
export function getEvalStatusEntry(code) {
    if (!code)
        return undefined;
    return EVAL_STATUS_TABLE.find(e => e.code === code.toLowerCase());
}
export function getEvalShortLabel(code) {
    return getEvalStatusEntry(code)?.shortLabel ?? "Unknown";
}
export function getEvalLongLabel(code) {
    return getEvalStatusEntry(code)?.longLabel ?? "Unknown";
}
export function getEvalColorClass(code) {
    return getEvalStatusEntry(code)?.colorClass ?? "bg-muted";
}
